import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';

import { CompanySearchComponent } from '~features/company/company-search/company-search.component';
import { CompanyGridComponent } from '~features/company-grid/company-grid/company-grid.component';
import { CompanyGridHighlightComponent } from '~features/company-grid/company-grid-highlight/company-grid-highlight.component';
import { CompanyScreenerComponent } from '~features/company-screener/company-screener.component';
import { AutoSliderLandingPageComponent } from '~features/custom-content-slider/auto-slider-landing-page/auto-slider-landing-page.component';
import { EventGridMixedComponent } from '~features/events/event-grid-mixed/event-grid-mixed.component';
import { SubscribeBannerComponent } from '~features/newsletter-subscription/subscribe-banner/subscribe-banner.component';
import { SEOService } from '~features/seo/seo.service';
import { TrackButtonClickDirective } from '~features/user-behavior-analytics/directives';
import { WeeklyScreenerTeaserListComponent } from '~features/weekly-screener/weekly-screener-teaser-list/weekly-screener-teaser-list.component';

@Component({
  selector: 'app-welcome-page',
  templateUrl: './welcome-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    EventGridMixedComponent,
    CompanyGridHighlightComponent,
    WeeklyScreenerTeaserListComponent,
    CompanyScreenerComponent,
    CompanySearchComponent,
    RouterLink,
    AutoSliderLandingPageComponent,
    CompanyGridComponent,
    SubscribeBannerComponent,
    FormsModule,
    ReactiveFormsModule,
    TrackButtonClickDirective,
  ],
})
export class WelcomePageComponent implements OnInit {
  @ViewChild('videoBlock', { static: true }) videoBlock: ElementRef;
  math = Math;

  constructor(private seoService: SEOService) {}

  public ngOnInit(): void {
    this.seoService.setMetaTags(null, null, null, null);
  }
}
